import { useNavigate } from 'react-router-dom';

import { Camera, getCameraStatusHelpText } from 'types/camera';

import { useDeleteCameras } from 'cameras/hooks/useDeleteCameras';
import { useHasAccess } from 'hooks/useHasAccess';
import { useModal } from 'hooks/useModal';
import { useMqttCamerasState } from 'cameras/hooks/useMqttCamerasState';

import { IconButton } from 'components/IconButton/IconButtonDeprecated';
import { StatusIndicator } from 'components/StatusIndicator/StatusIndicator';

export type CameraDetailStatusProps = {
  camera: Camera;
};

export function CameraDetailStatus({ camera }: CameraDetailStatusProps) {
  const navigate = useNavigate();
  const [hasAccess] = useHasAccess();

  const { open } = useModal();

  useMqttCamerasState([camera.id]);

  const { mutateAsync: deleteCameras, isLoading } = useDeleteCameras({
    onSuccess() {
      navigate('./..');
    },
  });

  function handleDeleteClick() {
    open('confirm-delete', {
      title: `Are you sure you want to delete ${camera.name}?`,
      onConfirm: () => deleteCameras({ camera_ids: [camera.id] }),
    });
  }

  return (
    <>
      <StatusIndicator
        status={camera.status}
        tooltip={getCameraStatusHelpText(camera)}
      />
      {hasAccess('deploy_edit') && (
        <IconButton
          icon="delete"
          label="Delete"
          onClick={handleDeleteClick}
          intent="danger"
          loading={isLoading}
          size="small"
          variant="secondary"
          showLabel
        />
      )}
    </>
  );
}
